import { render, staticRenderFns } from "./ViewAllNotes.vue?vue&type=template&id=0a01227b&scoped=true"
import script from "./ViewAllNotes.vue?vue&type=script&lang=js"
export * from "./ViewAllNotes.vue?vue&type=script&lang=js"
import style0 from "./ViewAllNotes.vue?vue&type=style&index=0&id=0a01227b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01227b",
  null
  
)

export default component.exports